import type { ReactNode } from 'react';
import { useContext, useState } from 'react';

import type { ErrorTracking } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

import { ErrorFallback } from './ErrorFallback.tsx';
import { ErrorBoundary } from './index.tsx';

export const ErrorFeedback = ({ children }: { children: ReactNode }) => {
  const { sendRequest } = useContext(MessagingContext)!;
  const [message, setMessage] = useState<{
    errorTitle: string;
    errorBody: string;
  }>({ errorTitle: '', errorBody: '' });
  const sendError = async (error: Error) => {
    const { result } = await sendRequest<ErrorTracking>('errorTracking', error);
    setMessage(result.message);
  };

  return (
    <ErrorBoundary
      FallbackComponent={() => <ErrorFallback message={message} />}
      onError={error => {
        sendError(error);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
